import { Injectable } from '@angular/core';
import { MonLog } from '../../model/monlogs/mon-log';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class MonLogsTableService extends BaseTableService<MonLog> {
  private additionalFilterOptions: any;

  constructor() {
    super();
  }

  getAdditionalFilterOptions(): any {
    return this.additionalFilterOptions;
  }

  setAdditionalFilterOptions(options: any): void {
    this.additionalFilterOptions = options;
  }
}
